import LocationOnIcon from '@mui/icons-material/LocationOn'
import VideoChatIcon from '@mui/icons-material/VideoChat'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import PersonIcon from '@mui/icons-material/Person'
import PhoneIcon from '@mui/icons-material/Phone'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import BusinessIcon from '@mui/icons-material/Business'
import EventIcon from '@mui/icons-material/Event'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { getPeekInForClinic, getPeekInExpiration, addOrUpdatePeekIn, isPeekInExpired } from './utils/peekInManager'
import { peekIntoRoom } from 'src/clinic/components/CheckIn/services'
import { Avatar, Paper, Tooltip, Box, Button, Chip, Divider, IconButton, Stack, Typography } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import FormControl from '@mui/material/FormControl'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'
import Select from '@mui/material/Select'
import { styled as muiStyled } from '@mui/material/styles'
import dayjs from 'dayjs'
import capitalize from 'lodash/capitalize'
import { useEffect, useState, useMemo, useRef, useCallback } from 'react'
import { Spinner } from 'react-bootstrap'
import PastTherapyReportDialog from 'src/clinic/components/ClinicManageBookingsPage/pastTherapyReports/PastTherapyReportDialog'
import { PastTherapyReportDialogPaper } from 'src/clinic/components/ClinicManageBookingsPage/receiptPrinting/styledComponents'
import PaymentLinksViewer from 'src/clinic/components/ClinicManageBookingsPage/slotItem/component/PaymentLinksViewer'
import {
  allAvailableEventTypes,
  BOOKED_EVENT_MODES,
  BOOKING_PAYMENT_STATUSES,
  BOOKING_STATUSES,
  displayNamesOfEventTypes,
  STATUS_SESSION_CANCELLED,
  VISIT_EVENT_TYPES,
} from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { formatPhoneNumber, openInNewTab , getTimezoneOffset} from 'src/consumer/helpers/utilFunctions'
import { cancelBookedSession } from 'src/consumer/services/featureServices'
import ListingVerticalStripForEventStatus from 'src/mentor/components/MentorEventsPage/components/bookingListing/LeftVerticalStripForEventStatus'
import { getImageLink, isCommonResponseSuccessful, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { GenericDisplayFlex, GenericDisplayFlexColumn } from 'src/mentor/layout/Styles'
import { getAllRolesInBoolean, getUserRoles } from 'src/mentor/layout/utils'
import { postMPDataWithoutParams } from 'src/mentor/services'
import { toast } from 'react-toastify'
import { useCheckInGuard } from './hooks/useCheckInGuard'
import CheckInDialogComponent from 'src/clinic/components/CheckIn'
import CheckoutPrompt from './components/CheckoutPrompt'
import MentorBookingCommunicationHub from 'src/mentor/components/contact/MentorBookingCommunicationHub'
import ReportViewDrawer from './components/ReportViewDrawer'
import { buildSupportBookedEventActionErrorMessage } from 'src/supportPortal/services/supportBookedEventRescheduleService'
import { canViewSupportReportForEventType } from 'src/supportPortal/access/accessMatrix'
import SupportReportViewDrawer from 'src/supportPortal/components/bookings/SupportReportViewDrawer'
import {
  CopyEventLinkButton,
  ScheduleName,
} from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import {
  BookedEventContainer,
  BookedEventTitle,
  EventsPageItemContainer,
  EventsPageMainItemsContainer,
  JoiningLink,
  StyledEventsRefreshIcon,
  InfoSection,
  InfoRow,
  InfoLabel,
  InfoValue,
} from './MentorEventsPageStyles'
import { formatScreeningSpecialtyLabel } from 'src/consumer/helpers/screeningSpecialtyUtils'

//////////////////////////////////////////////////////////////////////

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export default function MultipleSelectPanelMembers(props) {
  const { options, selected, handleMultiSelectPanelMembersChange } = props

  return (
    <div>
      <FormControl sx={{ m: 1, width: '100%' }}>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selected}
          onChange={handleMultiSelectPanelMembersChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => {
            if (selected?.length === 0) {
              return <span>No panel members selected</span>
            } else {
              return `${selected?.length} members selected`
            }
          }}
          MenuProps={MenuProps}
        >
          {options?.map((option, index) => (
            <MenuItem key={index} value={option?.id}>
              <Checkbox checked={selected?.indexOf(option?.id) > -1} />
              <ListItemText primary={option?.name} />
              <Avatar src={getImageLink(option?.profilePicId)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export function MentorEventSummaryComponent({
  onClickEvent,
  item,
  handleCopyEventLink,
  handleOpenBookingPage,
  readOnlyLabel = '',
  helperText = '',
  hideActions = false,
  hideAccessAndPricingDetails = false,
}) {
  const screeningSpecialtyLabel =
    item?.type === 'screening'
      ? formatScreeningSpecialtyLabel(item?.targetSpecialtySlug ?? item?.screeningType)
      : ''
  return (
    <EventsPageItemContainer onClick={onClickEvent} enabled={item?.enabled}>
      <ScheduleName main>{item?.title}</ScheduleName>
      <ScheduleName>
        {item?.meetingSrc === 'aumhum' ? <VideoChatIcon /> : <LocationOnIcon />}
        {item?.durationInMins} mins, {displayNamesOfEventTypes?.[item?.type]}
      </ScheduleName>
      {screeningSpecialtyLabel && <ScheduleName>Specialty: {screeningSpecialtyLabel}</ScheduleName>}
      {!hideAccessAndPricingDetails && (
        <ScheduleName>
          Buffer: {item?.preBufferMins} mins before, {item?.postBufferMins} mins after
        </ScheduleName>
      )}
      <ScheduleName style={{ color: item?.enabled ? 'green' : 'red' }}>
        {item?.enabled ? 'Enabled' : 'Disabled'}
      </ScheduleName>
      {!hideAccessAndPricingDetails && (
        <ScheduleName style={{ color: item?.publicEvent ? 'green' : 'red' }}>
          {item?.publicEvent ? 'Public' : 'Private'}
        </ScheduleName>
      )}
      {!hideAccessAndPricingDetails && (
        <ScheduleName style={{ color: !item?.free ? 'green' : 'red' }}>
          {item?.free ? 'Free' : 'Paid'}
        </ScheduleName>
      )}
      {readOnlyLabel && <ScheduleName style={{ color: '#9a3412' }}>{readOnlyLabel}</ScheduleName>}
      {helperText && <ScheduleName>{helperText}</ScheduleName>}
      {!hideActions && item?.uid && (
        <GenericDisplayFlex sb>
          <CopyEventLinkButton onClick={(e) => handleCopyEventLink(e, item)}>
            Copy Link
          </CopyEventLinkButton>
          <CopyEventLinkButton invert onClick={(e) => handleOpenBookingPage(e, item)}>
            View Booking Page
          </CopyEventLinkButton>
        </GenericDisplayFlex>
      )}
    </EventsPageItemContainer>
  )
}

export function MentorUpcomingPastEventsTable({
  mentorProfileData,
  allEvents,
  refreshEvents,
  loadingSlots,
  onClickJoin = () => {},
  eventFindLogicOverride = (eventItem, item) => eventItem?.uid === item?.eventTypeId,
  showMentorName = false,
  hideActions = false,
  hideAllActions = false,
  hidePortalVoiceCallAction = false,
  hideRefreshButton = false,
  openBookedEventLogsDialog,
  rightSideCustomComponent,
  onRescheduleBooking,
  cancelAppointmentApiSignature,
  skipCancelCheckInGuard = false,
  onEngagementClick, // Callback for engagement settings (support portal)
  communicationTargetsByBookedEventId = {},
  communicationTargetsLoading = false,
  communicationVisibleTargetKeys = undefined,
}) {
  const [bookedEventsSelectedView, setBookedEventsSelectedView] = useState('upcoming')
  const [currentTime, setCurrentTime] = useState(dayjs().format('YYYY-MM-DD HH:mm:ss'))
  const [cancelDialogData, setCancelDialogData] = useState(null)
  const [selectedBooking, setSelectedBooking] = useState(false)
  const [showPaymentLinksDialog, setShowPaymentLinksDialog] = useState(false)
  const [pastReportsDialog, setShowPastReports] = useState(false)

  // const upcomingBookedEvents = allEvents?.filter((item) =>
  //   dayjs?.utc(item?.endTime)?.local()?.isSameOrAfter(dayjs?.(currentTime)),
  // )
  // const pastBookedEvents = allEvents
  //   ?.filter((item) => dayjs?.utc(item?.endTime)?.local()?.isBefore(dayjs?.(currentTime)))
  //   ?.reverse()

  function openPaymentLinkPopup(item) {
    setSelectedBooking(item)
    setShowPaymentLinksDialog(true)
  }
  function closePaymentLinkPopup() {
    setSelectedBooking(null)
    setShowPaymentLinksDialog(false)
  }
  function openPastReportsDialog(item) {
    setSelectedBooking(item)
    setShowPastReports(true)
  }
  function closePastReportsDialog() {
    setShowPastReports(false)
    setSelectedBooking(null)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs().format('YYYY-MM-DD HH:mm:ss'))
    }, 60000)

    return () => clearInterval(interval)
  }, [])

  // Component to show clinic info with check-in/peek-in status tag
  function ClinicInfoRowWithStatus({ bookedEvent }) {
    const checkInGuard = useCheckInGuard(bookedEvent, {
      mentorProfileData,
      mentorClinicAssociationData: null, // Not needed for support portal
    })
    const isCheckedInOrPeekedIn = checkInGuard.isCheckedInOrPeekedIn
    const peekIn = isCheckedInOrPeekedIn?.isPeekedIn 
      ? getPeekInForClinic(bookedEvent?.clinicId)
      : null
    const peekInExpiration = peekIn ? getPeekInExpiration(peekIn) : null
    const [expirationUpdateTime, setExpirationUpdateTime] = useState(Date.now())

    // Update expiration display every minute
    useEffect(() => {
      if (peekInExpiration) {
        const interval = setInterval(() => {
          setExpirationUpdateTime(Date.now())
        }, 60000)

        return () => clearInterval(interval)
      }
    }, [peekInExpiration])

    return (
      <InfoRow>
        <BusinessIcon sx={{ fontSize: 16, color: '#9ca3af' }} />
        <InfoValue sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <span>
            {bookedEvent?.clinicBrandData?.brandName ||
              bookedEvent?.clinicBrandData?.title ||
              'Brand not recorded'}
            {bookedEvent?.clinicLocation?.title || bookedEvent?.clinicLocation?.name
              ? ` - ${bookedEvent?.clinicLocation?.title || bookedEvent?.clinicLocation?.name}`
              : ' - Location not recorded'}
          </span>
          {isCheckedInOrPeekedIn && (
            isCheckedInOrPeekedIn.isCheckedIn ? (
              <Chip
                label="Checked In"
                size="small"
                sx={{
                  height: 18,
                  fontSize: '10px',
                  bgcolor: '#10b981',
                  color: 'white',
                  fontWeight: 600,
                }}
              />
            ) : (
              <Chip
                label={peekInExpiration ? `Peeked In (expires ${dayjs(peekInExpiration).local().format('h:mm A')})` : 'Peeked In'}
                size="small"
                sx={{
                  height: 18,
                  fontSize: '10px',
                  bgcolor: '#6366f1',
                  color: 'white',
                  fontWeight: 600,
                }}
                key={expirationUpdateTime}
              />
            )
          )}
        </InfoValue>
      </InfoRow>
    )
  }

  // Component to show check-in/peek-in status on card
  function CheckInStatusIndicator({ bookedEvent }) {
    const checkInGuard = useCheckInGuard(bookedEvent, {
      mentorProfileData,
      mentorClinicAssociationData: null, // Not needed for support portal
    })
    const { isCheckedInOrPeekedIn, handleCheckout } = checkInGuard
    const [expirationUpdateTime, setExpirationUpdateTime] = useState(Date.now())
    
    if (!isCheckedInOrPeekedIn) return null

    // Check if peeked in (with expiration)
    const peekIn = isCheckedInOrPeekedIn.isPeekedIn 
      ? getPeekInForClinic(bookedEvent?.clinicId)
      : null
    const peekInExpiration = peekIn ? getPeekInExpiration(peekIn) : null

    // Update expiration display every minute
    useEffect(() => {
      if (peekInExpiration) {
        const interval = setInterval(() => {
          setExpirationUpdateTime(Date.now())
        }, 60000) // Every minute

        return () => clearInterval(interval)
      }
    }, [peekInExpiration])
    
    // Show checked-in status
    if (isCheckedInOrPeekedIn.isCheckedIn) {
      return (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          mb: 0.5,
          p: 0.75,
          bgcolor: '#10b98110',
          borderRadius: '8px',
          border: '1px solid #10b98130'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <CheckCircleIcon sx={{ fontSize: 18, color: '#10b981' }} />
            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#10b981' }}>
              Checked In
            </Typography>
          </Box>
          <Tooltip title="Check Out">
            <IconButton
              size="small"
              onClick={() => handleCheckout()}
              sx={{
                color: '#ef4444',
                '&:hover': { bgcolor: '#ef444410' },
                p: 0.5,
              }}
            >
              <ExitToAppIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }

    // Show peek-in status with expiration
    if (isCheckedInOrPeekedIn.isPeekedIn && peekIn) {
      return (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          mb: 0.5,
          p: 0.75,
          bgcolor: '#6366f110',
          borderRadius: '8px',
          border: '1px solid #6366f130'
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <VisibilityIcon sx={{ fontSize: 18, color: '#6366f1' }} />
              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#6366f1' }}>
                Peeked In
              </Typography>
            </Box>
            {peekInExpiration && (
              <Typography 
                sx={{ fontSize: '11px', color: '#6366f1', ml: 3.5 }}
                key={expirationUpdateTime} // Force re-render on update
              >
                Expires at {dayjs(peekInExpiration).local().format('h:mm A')}
              </Typography>
            )}
          </Box>
          <Tooltip title="Exit Peek-in">
            <IconButton
              size="small"
              onClick={() => handleCheckout()}
              sx={{
                color: '#ef4444',
                '&:hover': { bgcolor: '#ef444410' },
                p: 0.5,
              }}
            >
              <ExitToAppIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }

    return null
  }

  function BookingSummaryTile({ icon, label, primary, secondary, children }) {
    return (
      <Box
        sx={{
          minWidth: 0,
          p: 1.15,
          borderRadius: 3,
          border: '1px solid rgba(148, 163, 184, 0.18)',
          background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.96) 0%, rgba(255, 255, 255, 1) 100%)',
          boxShadow: '0 8px 22px rgba(15, 23, 42, 0.04)',
        }}
      >
        <Stack spacing={0.75}>
          <Stack direction="row" spacing={0.85} alignItems="center" sx={{ minWidth: 0 }}>
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 2,
                display: 'grid',
                placeItems: 'center',
                background: 'rgba(99, 102, 241, 0.12)',
                color: '#4f46e5',
                flexShrink: 0,
              }}
            >
              {icon}
            </Box>
            <Typography
              variant="caption"
              sx={{
                color: '#64748b',
                fontWeight: 800,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
              }}
            >
              {label}
            </Typography>
          </Stack>
          {primary ? (
            <Typography
              variant="body2"
              sx={{
                color: '#0f172a',
                fontWeight: 700,
                lineHeight: 1.35,
                wordBreak: 'break-word',
              }}
            >
              {primary}
            </Typography>
          ) : null}
          {secondary ? (
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.45 }}>
              {secondary}
            </Typography>
          ) : null}
          {children}
        </Stack>
      </Box>
    )
  }

  function BookingActionButton({ label, onClick, color = 'inherit', variant = 'outlined', style = {} }) {
    return (
      <Button
        size="small"
        variant={variant}
        color={color}
        onClick={onClick}
        sx={{
          borderRadius: '999px',
          textTransform: 'none',
          fontWeight: 700,
          minHeight: 34,
          px: 1.25,
          ...style,
        }}
      >
        {label}
      </Button>
    )
  }

  function BookedEventActions({ bookedEvent }) {
    const checkInGuard = useCheckInGuard(bookedEvent, {
      mentorProfileData,
      mentorClinicAssociationData: null, // Not needed for support portal
    })
    const {
      checkInPromptOpen,
      checkoutPromptOpen,
      checkingIn,
      availableRooms,
      selectedRoom,
      clinicLocationData,
      clinicBrandData,
      requireCheckIn,
      handleCheckIn,
      handlePeekIn,
      handleCheckout,
      setCheckInPromptOpen,
      setCheckoutPromptOpen,
      setSelectedRoom,
      isCheckedInOrPeekedIn,
    } = checkInGuard

    // State for report drawer
    const [reportDrawerOpen, setReportDrawerOpen] = useState(false)
    const [reportDrawerType, setReportDrawerType] = useState(null)
    const [supportReportDrawerOpen, setSupportReportDrawerOpen] = useState(false)
    
    // Store the room data when dialog opens to prevent unmounting during refetch
    const [dialogRoomData, setDialogRoomData] = useState(null)
    
    // Update dialogRoomData when dialog opens and we have rooms
    useEffect(() => {
      if (checkInPromptOpen && availableRooms.length > 0 && clinicLocationData) {
        // Store the first available room to prevent unmounting during refetch
        setDialogRoomData(availableRooms[0])
      } else if (!checkInPromptOpen) {
        // Clear when dialog closes
        setDialogRoomData(null)
      }
    }, [checkInPromptOpen, availableRooms, clinicLocationData])

    // Check if session has started (startTime is in the past or now)
    const hasSessionStarted = useMemo(() => {
      if (!bookedEvent?.startTime) return false
      const sessionStartTime = dayjs.utc(bookedEvent.startTime).local()
      const now = dayjs(currentTime)
      return sessionStartTime.isSameOrBefore(now)
    }, [bookedEvent?.startTime, currentTime])

    const isSupportPortal = useMemo(() => {
      if (typeof window === 'undefined') {
        return false
      }
      const pathname = window.location?.pathname || ''
      return pathname.startsWith('/support-home') || pathname.startsWith('/support/')
    }, [])

    const currentUserRoles = useMemo(() => getUserRoles() || [], [])
    const canViewSupportReport = useMemo(
      () =>
        isSupportPortal &&
        canViewSupportReportForEventType(currentUserRoles, bookedEvent?.eventType),
      [bookedEvent?.eventType, currentUserRoles, isSupportPortal],
    )

    // Helper function to do silent peek-in for video calls
    const doSilentPeekInForVideoCall = async (onSuccess) => {
      if (!clinicLocationData) {
        requireCheckIn(onSuccess)
        return
      }
      
      // Check if already peeked in
      const existingPeekIn = getPeekInForClinic(clinicLocationData.id)
      if (existingPeekIn && !isPeekInExpired(existingPeekIn)) {
        // Already peeked in and not expired, proceed directly
        onSuccess()
        return
      }
      
      // Get clinic location short name and slug
      const clinicShortName = clinicLocationData?.shortName || 
                              clinicLocationData?.short_name || 
                              clinicLocationData?.nickName || 
                              clinicLocationData?.nickname ||
                              clinicLocationData?.name ||
                              'Clinic'
      
      const clinicSlug = clinicLocationData?.slug || 
                        clinicLocationData?.clinicSlug ||
                        clinicLocationData?.id?.toString() ||
                        'clinic'
      
      // Create custom video call room
      // Note: peek-in API doesn't require selectedCheckInEventOption
      const videoCallRoom = {
        id: `${clinicSlug}--video-call-room`,
        title: `${clinicShortName}: Video Call Room`,
        name: `${clinicShortName}: Video Call Room`,
        clinicLocationId: clinicLocationData.id,
        clinicBrandId: clinicLocationData.clinicBrandId || bookedEvent?.clinicBrandId,
      }
      
      // Do silent peek-in
      try {
        const response = await peekIntoRoom(videoCallRoom)
        if (response?.status === 200) {
          // Add to peek-in manager with 1 hour expiration
          addOrUpdatePeekIn(videoCallRoom)
          // Proceed with the action
          onSuccess()
        } else {
          console.error('Peek-in API failed:', response)
          // If peek-in fails, fall back to normal check-in flow
          requireCheckIn(onSuccess)
        }
      } catch (error) {
        console.error('Error doing silent peek-in:', error)
        // If peek-in fails, fall back to normal check-in flow
        requireCheckIn(onSuccess)
      }
    }

    // Helper function to do silent peek-in for editing reports
    // For offline sessions: uses <Clinic-Location-Slug>--Editing-Room
    // For video call sessions: uses <Clinic Location Slug>--video-call-room
    const doSilentPeekInForEditing = async (onSuccess) => {
      if (!clinicLocationData) {
        requireCheckIn(onSuccess)
        return
      }
      
      // Check if already peeked in
      const existingPeekIn = getPeekInForClinic(clinicLocationData.id)
      if (existingPeekIn && !isPeekInExpired(existingPeekIn)) {
        // Already peeked in and not expired, proceed directly
        onSuccess()
        return
      }
      
      // Get clinic location short name and slug
      const clinicShortName = clinicLocationData?.shortName || 
                              clinicLocationData?.short_name || 
                              clinicLocationData?.nickName || 
                              clinicLocationData?.nickname ||
                              clinicLocationData?.name ||
                              'Clinic'
      
      const clinicSlug = clinicLocationData?.slug || 
                        clinicLocationData?.clinicSlug ||
                        clinicLocationData?.id?.toString() ||
                        'clinic'
      
      const isVideoCall = bookedEvent?.meetingSrc === 'aumhum'
      
      // Determine room ID based on session type
      let roomId, roomTitle, roomName
      if (isVideoCall) {
        // Video call: use video-call-room
        roomId = `${clinicSlug}--video-call-room`
        roomTitle = `${clinicShortName}: Video Call Room`
        roomName = `${clinicShortName}: Video Call Room`
      } else {
        // Offline: use Editing-Room
        roomId = `${clinicSlug}--Editing-Room`
        roomTitle = `${clinicShortName}: Editing Room`
        roomName = `${clinicShortName}: Editing Room`
      }
      
      // Create custom room for editing
      const editingRoom = {
        id: roomId,
        title: roomTitle,
        name: roomName,
        clinicLocationId: clinicLocationData.id,
        clinicBrandId: clinicLocationData.clinicBrandId || bookedEvent?.clinicBrandId,
      }
      
      // Do silent peek-in
      try {
        const response = await peekIntoRoom(editingRoom)
        if (response?.status === 200) {
          // Add to peek-in manager with 1 hour expiration
          addOrUpdatePeekIn(editingRoom)
          // Proceed with the action
          onSuccess()
        } else {
          console.error('Peek-in API failed:', response)
          // If peek-in fails, fall back to normal check-in flow
          requireCheckIn(onSuccess)
        }
      } catch (error) {
        console.error('Error doing silent peek-in:', error)
        // If peek-in fails, fall back to normal check-in flow
        requireCheckIn(onSuccess)
      }
    }

    // Handler for "No Notes" - uses silent peek-in
    const handleNoNotes = () => {
      // Use silent peek-in with appropriate room based on session type
      doSilentPeekInForEditing(() => {
        toast.info('No notes available for this appointment.')
      })
    }

    // Wrapper functions that require check-in
    const handlePrescription = () => {
      // Use silent peek-in with appropriate room based on session type
      doSilentPeekInForEditing(() => {
        setReportDrawerType('prescription')
        setReportDrawerOpen(true)
      })
    }

    const handleScreeningReport = () => {
      // Use silent peek-in with appropriate room based on session type
      doSilentPeekInForEditing(() => {
        setReportDrawerType('screening-report')
        setReportDrawerOpen(true)
      })
    }

    const handleTherapyReport = () => {
      // Use silent peek-in with appropriate room based on session type
      doSilentPeekInForEditing(() => {
        setReportDrawerType('therapy-report')
        setReportDrawerOpen(true)
      })
    }

    const handlePatientHistory = () => {
      // Use silent peek-in with appropriate room based on session type
      doSilentPeekInForEditing(() => {
        openPastReportsDialog(bookedEvent)
      })
    }

    const handleStart = async () => {
      const isVideoCall = bookedEvent?.meetingSrc === 'aumhum'
      
      // For video calls, do silent peek-in instead of showing check-in popup
      if (isVideoCall && clinicLocationData) {
        // Use the helper function for silent peek-in
        await doSilentPeekInForVideoCall(() => {
          onClickJoin(bookedEvent)
        })
        return
      }
      
      // For in-person (offline) sessions, show check-in prompt even if peeked-in
      const isInPersonSession = !isVideoCall
      const isOnlyPeekedIn = isCheckedInOrPeekedIn?.isPeekedIn && !isCheckedInOrPeekedIn?.isCheckedIn
      
      // Force check-in prompt for in-person sessions when only peeked-in
      const forceCheckIn = isInPersonSession && isOnlyPeekedIn
      
      requireCheckInWithAction(() => {
        onClickJoin(bookedEvent)
      }, forceCheckIn)
    }

    // Handler for "Peek-in & Edit Report" button
    const handlePeekInAndEditReport = async () => {
      // Use silent peek-in for editing (uses appropriate room based on session type)
      await doSilentPeekInForEditing(() => {
        onClickJoin(bookedEvent)
      })
    }

    const handleCancel = () => {
      if (skipCancelCheckInGuard) {
        setCancelDialogData(bookedEvent)
        return
      }

      const isVideoCall = bookedEvent?.meetingSrc === 'aumhum'
      if (isVideoCall) {
        doSilentPeekInForVideoCall(() => {
          setCancelDialogData(bookedEvent)
        })
      } else {
        requireCheckIn(() => {
          setCancelDialogData(bookedEvent)
        })
      }
    }

    const handleReschedule = () => {
      if (onRescheduleBooking) {
        onRescheduleBooking(bookedEvent)
        return
      }

      const isVideoCall = bookedEvent?.meetingSrc === 'aumhum'
      const rescheduleAction = async () => {
        // Open a simple prompt for reschedule date/time
        const newDateStr = prompt('Enter new date and time (YYYY-MM-DD HH:mm):')
        if (!newDateStr) return

        try {
          const newStartTime = dayjs(newDateStr).utc().toISOString()
          const payload = {
            bookedEventId: bookedEvent.id,
            newStartTime: newStartTime,
            notifyPatient: true,
            reason: 'Rescheduling appointment',
            forceReschedule: false,
            reschedulePolicy: 'DONT_BOOK_IF_CONFLICT',
          }

          const response = await postMPDataWithoutParams(
            '/api/secure/mentor/booked-events/reschedule',
            payload
          )

          if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
            toast.success('Booking rescheduled successfully')
            if (refreshEvents) {
              refreshEvents()
            }
          } else {
            const errorCode = response?.data?.code
            let errorMessage = response?.data?.message || 'Failed to reschedule booking'
            
            if (errorCode === 4443) {
              errorMessage = 'Booking already marked completed. Rescheduling is not permitted.'
            } else if (errorCode === 4444) {
              errorMessage = 'Requested time is in the past. Please select a future time.'
            } else if (errorCode === 4448 || errorCode === 4449) {
              errorMessage = 'Time slot conflicts with another booking. Please select a different time or use force reschedule.'
            } else if (errorCode === 48980) {
              errorMessage = 'Self-reschedule is disabled for this clinic. Please contact support.'
            }
            
            toast.error(errorMessage)
          }
        } catch (error) {
          console.error('Error rescheduling booking:', error)
          toast.error('Failed to reschedule booking. Please try again.')
        }
      }
      
      if (isVideoCall) {
        doSilentPeekInForVideoCall(rescheduleAction)
      } else {
        requireCheckIn(rescheduleAction)
      }
    }

    const handleBookingLogs = () => {
      // Use silent peek-in with appropriate room based on session type
      doSilentPeekInForEditing(() => {
        openBookedEventLogsDialog(bookedEvent)
      })
    }

    const handlePaymentLinks = () => {
      requireCheckIn(() => {
        openPaymentLinkPopup(bookedEvent)
      })
    }

    // Store pending action to execute after check-in completes
    const pendingActionAfterCheckInRef = useRef(null)
    
    // Wrapper for requireCheckIn that stores the action
    const requireCheckInWithAction = useCallback(
      async (actionCallback, forceCheckIn = false) => {
        // Store the action to execute after check-in
        pendingActionAfterCheckInRef.current = actionCallback
        // Call the original requireCheckIn (it will show the dialog)
        requireCheckIn(actionCallback, forceCheckIn)
      },
      [requireCheckIn]
    )
    
    // Execute pending action after check-in
    const executePendingAction = useCallback(() => {
      if (pendingActionAfterCheckInRef.current) {
        const action = pendingActionAfterCheckInRef.current
        pendingActionAfterCheckInRef.current = null
        // Small delay to ensure check-in is fully processed
        setTimeout(() => {
          action()
        }, 100)
      }
    }, [])

    // Check if session is blocked (payment pending - slot held but not confirmed)
    const isSessionBlocked = 
      bookedEvent?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
      bookedEvent?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING

    return (
      <>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.9,
            alignItems: 'center',
          }}
        >
          {/* Hide Start button for blocked sessions - no one can join blocked sessions */}
          {!hideActions && bookedEvent?.status !== STATUS_SESSION_CANCELLED && !isSessionBlocked && (
            <>
              {isSupportPortal ? (
                canViewSupportReport ? (
                  <BookingActionButton label="View Report" onClick={() => setSupportReportDrawerOpen(true)} />
                ) : null
              ) : (
                <>
                  {bookedEvent?.meetingSrc === 'aumhum' ? (
                    <BookingActionButton label="Start" onClick={handleStart} variant="contained" color="primary" />
                  ) : (
                    <BookingActionButton label="Peek-in & Edit Report" onClick={handlePeekInAndEditReport} />
                  )}
                </>
              )}
            </>
          )}
          {/* Show blocked status indicator */}
          {isSessionBlocked && (
            <Chip
              label="Awaiting Payment"
              size="small"
              sx={{
                bgcolor: '#fef3c7',
                color: '#92400e',
                fontWeight: 700,
              }}
            />
          )}
          {bookedEvent?.status === STATUS_SESSION_CANCELLED && (
            <Chip label="Cancelled" size="small" color="error" variant="outlined" />
          )}
          {bookedEvent?.modificationHistory?.length > 0 &&
            bookedEvent?.modificationHistory?.some((hist) => {
              return hist?.event === 'booking-rescheduled'
            }) && <Chip label="Rescheduled" size="small" color="info" variant="outlined" />}
          {!hideActions && (
            <>
              {bookedEvent?.status !== STATUS_SESSION_CANCELLED && (
                <>
                  {/* Only show notes and report links if payment status is paid */}
                  {!isSupportPortal && bookedEvent?.paymentStatus === BOOKING_PAYMENT_STATUSES.PAID && (
                    <>
                      <BookingActionButton label="No Notes" onClick={handleNoNotes} />
                      {hasSessionStarted && (
                        <>
                          {bookedEvent?.patientId &&
                            getAllRolesInBoolean().isDoctor &&
                            mentorProfileData?.allowedToPrescribe && (
                              <BookingActionButton label="Prescription" onClick={handlePrescription} />
                            )}
                          {bookedEvent?.patientId &&
                            bookedEvent?.eventType === allAvailableEventTypes.screening && (
                              <BookingActionButton label="Screening Report" onClick={handleScreeningReport} />
                            )}
                          {bookedEvent?.patientId &&
                            bookedEvent?.eventType === allAvailableEventTypes.therapySession && (
                              <BookingActionButton label="Therapy Report" onClick={handleTherapyReport} />
                            )}
                        </>
                      )}
                      <BookingActionButton label="Patient History" onClick={handlePatientHistory} />
                    </>
                  )}
                  {!bookedEvent?.markedCompleted && (
                    <>
                      <BookingActionButton label="Reschedule" onClick={handleReschedule} />
                      <BookingActionButton label="Cancel" onClick={handleCancel} color="error" />
                    </>
                  )}
                </>
              )}
            </>
          )}
          {bookedEvent?.status === BOOKING_STATUSES.BOOKED &&
            bookedEvent?.paymentStatus === BOOKING_PAYMENT_STATUSES.PAID &&
            hasSessionStarted && (
              <BookingActionButton label="Join/Leave Logs" onClick={handleBookingLogs} />
            )}
          {((bookedEvent?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
            bookedEvent?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING) ||
            bookedEvent?.paymentLinks?.length > 0) && (
            <BookingActionButton label="View Payment Links" onClick={handlePaymentLinks} />
          )}
          {/* Engagement Settings - for support portal */}
          {onEngagementClick && bookedEvent?.status === BOOKING_STATUSES.BOOKED && (
            <BookingActionButton
              label="Engagement"
              onClick={() => onEngagementClick(bookedEvent)}
              style={{ color: '#8b5cf6', borderColor: 'rgba(139, 92, 246, 0.32)' }}
            />
          )}
        </Box>

        {checkInPromptOpen && dialogRoomData && clinicLocationData && (
          <CheckInDialogComponent
            closeFunction={() => {
              setCheckInPromptOpen(false)
              setDialogRoomData(null)
              pendingActionAfterCheckInRef.current = null
            }}
            roomData={dialogRoomData} // Use stored room data to prevent unmounting during refetch
            clinicLocationData={clinicLocationData}
            disableTimeout={true} // Disable auto-close timeout for manage-my-bookings page
            onChoosingInPerson={async () => {
              setCheckInPromptOpen(false)
              setDialogRoomData(null)
              executePendingAction()
            }}
            onChoosingRemote={async () => {
              setCheckInPromptOpen(false)
              setDialogRoomData(null)
              executePendingAction()
            }}
          />
        )}

        <CheckoutPrompt
          open={checkoutPromptOpen}
          onClose={() => setCheckoutPromptOpen(false)}
          onCheckout={handleCheckout}
          checkingOut={checkingIn}
        />

        <ReportViewDrawer
          open={reportDrawerOpen}
          onClose={() => setReportDrawerOpen(false)}
          bookedEvent={bookedEvent}
          reportType={reportDrawerType}
        />

        <SupportReportViewDrawer
          open={supportReportDrawerOpen}
          onClose={() => setSupportReportDrawerOpen(false)}
          bookedEvent={bookedEvent}
        />
      </>
    )
  }

  function renderRightSideCustomComponent(bookedEvent) {
    const defaultActions = !hideAllActions ? <BookedEventActions bookedEvent={bookedEvent} /> : null

    if (rightSideCustomComponent) {
      const customContent = rightSideCustomComponent({ event: bookedEvent, defaultActions })
      return customContent ?? defaultActions
    }

    return defaultActions
  }

  return (
    <>
      {!hideRefreshButton && (
        <GenericDisplayFlex sb style={{ flexWrap: 'wrap', padding: '20px', paddingBottom: '0' }}>
          <GenericDisplayFlex style={{ flexWrap: 'wrap', gap: '20px' }}>
            {/* <NewEventTypeButton
            selected={bookedEventsSelectedView === 'upcoming'}
            MRZERO
            onClick={() => setBookedEventsSelectedView('upcoming')}
          >
            Active/ Upcoming
          </NewEventTypeButton>
          <NewEventTypeButton
            selected={bookedEventsSelectedView === 'past'}
            onClick={() => setBookedEventsSelectedView('past')}
          >
            Past
          </NewEventTypeButton> */}
          </GenericDisplayFlex>
          {loadingSlots ? (
            <Spinner animation="border" variant="dark" size="sm" />
          ) : (
            <Tooltip title={<strong>Refresh Bookings</strong>}>
              <StyledEventsRefreshIcon onClick={refreshEvents} />
            </Tooltip>
          )}
        </GenericDisplayFlex>
      )}
      <EventsPageMainItemsContainer>
        {allEvents?.map((bookedEvent, index) => {
          const matchedEvent = allEvents?.find((eventItem) => eventFindLogicOverride(eventItem, bookedEvent))
          const patientName = bookedEvent?.patientInfoData?.name || bookedEvent?.userName || 'Participant'
          const patientAgeGenderLabel = bookedEvent?.patientInfoData?.dateOfBirth
            ? `${getAgeFromDobWithTime(bookedEvent?.patientInfoData?.dateOfBirth)} Y | ${capitalize(bookedEvent?.patientInfoData?.gender)}`
            : capitalize(bookedEvent?.patientInfoData?.gender || '')
          const patientPhoneLabel = bookedEvent?.patientInfoData?.mobile
            ? formatPhoneNumber(bookedEvent?.patientInfoData?.mobile)?.concatenatedString || bookedEvent?.patientInfoData?.mobile
            : ''
          const sessionDateLabel = bookedEvent?.startTime
            ? dayjs?.utc(bookedEvent?.startTime).local()?.format('dddd, D MMMM YYYY')
            : 'Date not recorded'
          const sessionTimeLabel = bookedEvent?.startTime && bookedEvent?.endTime
            ? `${dayjs?.utc(bookedEvent?.startTime).local()?.format('h:mma')} - ${dayjs?.utc(bookedEvent?.endTime).local()?.format('h:mma')} (${getTimezoneOffset()})`
            : 'Time not recorded'
          const sessionTitleLabel = [
            matchedEvent?.title || '',
            displayNamesOfEventTypes?.[bookedEvent?.eventType] || 'Session',
          ]
            .filter(Boolean)
            .join(' • ')
          const clinicSummaryLabel =
            bookedEvent?.clinicBrandData?.brandName ||
            bookedEvent?.clinicBrandData?.title ||
            'Brand not recorded'
          const locationSummaryLabel =
            bookedEvent?.clinicLocation?.title ||
            bookedEvent?.clinicLocation?.name ||
            'Location not recorded'
          const meetingModeLabel = BOOKED_EVENT_MODES?.[bookedEvent?.meetingSrc]?.title || 'In-Person'

          return (
            <BookedEventContainer 
              key={`card-${index}`}
              data-card-index={index}
              sessionStatus={bookedEvent?.sessionStatus}
              markedCompleted={bookedEvent?.markedCompleted}
              status={bookedEvent?.status}
              visitEventType={bookedEvent?.visitEventType}
              paymentStatus={bookedEvent?.paymentStatus}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1.5,
                  flex: '1 1 540px',
                  minWidth: 0,
                }}
              >
                {bookedEvent?.visitEventType === VISIT_EVENT_TYPES.emergency && (
                  <Tooltip title="Emergency Session">
                    <LocalHospitalIcon 
                      sx={{ 
                        color: '#EF4444', 
                        fontSize: 24,
                        marginRight: '8px'
                      }} 
                    />
                  </Tooltip>
                )}
                <ListingVerticalStripForEventStatus bookedEventData={bookedEvent} />
                <Box 
                  sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1.1, minWidth: 0 }}
                >
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={1}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', md: 'flex-start' }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.85, flexWrap: 'wrap' }}>
                        <PersonIcon sx={{ fontSize: 18, color: '#4f46e5' }} />
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 800,
                            color: '#0f172a',
                            lineHeight: 1.2,
                            wordBreak: 'break-word',
                          }}
                        >
                          {patientName}
                        </Typography>
                        {bookedEvent?.patientInfoData?.patientNumber ? (
                          <Chip
                            label={`#${bookedEvent.patientInfoData.patientNumber}`}
                            size="small"
                            sx={{
                              height: 22,
                              bgcolor: 'rgba(79, 70, 229, 0.1)',
                              color: '#4338ca',
                              fontWeight: 700,
                            }}
                          />
                        ) : null}
                        {patientAgeGenderLabel ? (
                          <Chip
                            label={patientAgeGenderLabel}
                            size="small"
                            sx={{
                              height: 22,
                              bgcolor: 'rgba(148, 163, 184, 0.14)',
                              color: '#475569',
                            }}
                          />
                        ) : null}
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          mt: 0.45,
                          color: '#64748b',
                          lineHeight: 1.35,
                        }}
                      >
                        {sessionTitleLabel}
                      </Typography>
                    </Box>

                    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                      <Chip
                        size="small"
                        label={meetingModeLabel}
                        sx={{
                          height: 24,
                          bgcolor: 'rgba(37, 99, 235, 0.08)',
                          color: '#1d4ed8',
                          fontWeight: 700,
                        }}
                      />
                      {bookedEvent?.visitEventType === VISIT_EVENT_TYPES.emergency ? (
                        <Chip size="small" color="error" label="Emergency" sx={{ height: 24, fontWeight: 700 }} />
                      ) : null}
                    </Stack>
                  </Stack>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                    {showMentorName && bookedEvent?.mentorName ? (
                      <Chip size="small" variant="outlined" label={`With ${bookedEvent.mentorName}`} />
                    ) : null}
                    {bookedEvent?.patientMeetingSeqNumber ? (
                      <Chip size="small" variant="outlined" label={`Visit #${bookedEvent.patientMeetingSeqNumber}`} />
                    ) : null}
                    {patientPhoneLabel ? (
                      <Chip size="small" variant="outlined" icon={<PhoneIcon sx={{ fontSize: 14 }} />} label={patientPhoneLabel} />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
                      gap: 1,
                    }}
                  >
                    <BookingSummaryTile
                      icon={<CalendarTodayIcon sx={{ fontSize: 17 }} />}
                      label="When"
                      primary={sessionDateLabel}
                      secondary={sessionTimeLabel}
                    />
                    <BookingSummaryTile
                      icon={<EventIcon sx={{ fontSize: 17 }} />}
                      label="Session"
                      primary={sessionTitleLabel}
                      secondary={`${clinicSummaryLabel} • ${locationSummaryLabel}`}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, pt: 0.25, flexWrap: 'wrap' }}>
                        {bookedEvent?.meetingSrc === 'aumhum' ? (
                          <VideoChatIcon sx={{ fontSize: 15, color: '#64748b' }} />
                        ) : (
                          <LocationOnIcon sx={{ fontSize: 15, color: '#64748b' }} />
                        )}
                        <Typography variant="caption" color="text.secondary">
                          {meetingModeLabel}
                        </Typography>
                      </Box>
                    </BookingSummaryTile>
                  </Box>

                  <Box
                    sx={{
                      px: 1,
                      py: 0.85,
                      borderRadius: 2.5,
                      border: '1px solid rgba(148, 163, 184, 0.18)',
                      background: 'rgba(248, 250, 252, 0.72)',
                    }}
                  >
                    <ClinicInfoRowWithStatus bookedEvent={bookedEvent} />
                  </Box>

                  {bookedEvent?.blockedNextVisitSlot &&
                    !!bookedEvent?.blockedNextVisitSlot?.startTime && (
                      <Box
                        sx={{
                          px: 1.1,
                          py: 0.9,
                          borderRadius: 2.5,
                          border: '1px solid rgba(16, 185, 129, 0.22)',
                          background: 'linear-gradient(135deg, rgba(236, 253, 245, 0.96) 0%, rgba(240, 253, 250, 0.9) 100%)',
                        }}
                      >
                        <Stack direction="row" spacing={0.8} alignItems="center">
                          <CalendarTodayIcon sx={{ fontSize: 16, color: '#10b981' }} />
                          <Typography variant="body2" sx={{ color: '#047857', fontWeight: 700, lineHeight: 1.4 }}>
                            Next visit:{' '}
                            {dayjs
                              ?.utc(bookedEvent?.blockedNextVisitSlot?.startTime)
                              .local()
                              ?.format('dddd, D MMMM YYYY, h:mmA')}
                          </Typography>
                        </Stack>
                      </Box>
                    )}
                </Box>
              </Box>
              {bookedEvent?.id && !hidePortalVoiceCallAction ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: { xs: '1 1 100%', lg: '0 1 390px' },
                    minWidth: 0,
                    alignSelf: { xs: 'stretch', lg: 'flex-start' },
                  }}
                >
                  <MentorBookingCommunicationHub
                    bookedEvent={bookedEvent}
                    prefetchedTargets={communicationTargetsByBookedEventId?.[bookedEvent?.id] || null}
                    prefetchedTargetsLoading={
                      communicationTargetsLoading && !communicationTargetsByBookedEventId?.[bookedEvent?.id]
                    }
                    visibleTargetKeys={communicationVisibleTargetKeys}
                  />
                </Box>
              ) : null}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flex: '1 1 100%',
                  width: '100%',
                }}
              >
                {renderRightSideCustomComponent(bookedEvent)}
              </Box>
            </BookedEventContainer>
          )
        })}

        {allEvents?.length === 0 && <BookedEventTitle>No bookings</BookedEventTitle>}
      </EventsPageMainItemsContainer>
      <Dialog
        open={showPaymentLinksDialog}
        maxWidth="lg"
        fullWidth
        // PaperComponent={StyledRequestTherapyComponent}
        // PaperProps={{
        //   onKeyDown: handleKeyDown, // Prevent Escape key from closing it
        // }}
        onClose={closePaymentLinkPopup}
      >
        <PaymentLinksViewer
          bookedSlot={selectedBooking}
          closeDialog={closePaymentLinkPopup}
          refreshBookedSlots={refreshEvents}
        />
      </Dialog>
      <Dialog
        open={pastReportsDialog}
        PaperComponent={PastTherapyReportDialogPaper}
        onClose={closePastReportsDialog}
      >
        <PastTherapyReportDialog
          bookedEvent={selectedBooking}
          closeDialog={closePastReportsDialog}
        />
      </Dialog>
      {cancelDialogData && (
        <ConfirmCancelSessionDialog
          open={cancelDialogData}
          closeFunc={() => setCancelDialogData(null)}
          sessionData={cancelDialogData}
          afterCancelSuccess={refreshEvents}
          cancelAppointmentApiSignature={cancelAppointmentApiSignature}
        />
      )}
    </>
  )
}

export const ConfirmCancelSessionDialog = ({
  open,
  closeFunc,
  sessionData,
  afterCancelSuccess,
  cancelAppointmentApiSignature,
}) => {
  const [cancelLoading, setCancelLoading] = useState(false)
  const [reason, setReason] = useState('')
  const [refundType, setRefundType] = useState('none')
  const [submitError, setSubmitError] = useState('')

  async function cancelSession() {
    if (!reason.trim()) {
      // Reason is optional, but we can show a warning or allow empty
      // For now, we'll allow empty reason
    }

    setSubmitError('')
    setCancelLoading(true)
    const response = await cancelBookedSession(
      cancelAppointmentApiSignature, 
      sessionData?.id,
      reason.trim() || null,
      refundType,
      sessionData?.slug // bookedEventSlug
    )
    setCancelLoading(false)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      if (afterCancelSuccess) {
        afterCancelSuccess()
      }
      if (closeFunc) {
        closeFunc()
      }
      // Reset form
      setReason('')
      setRefundType('none')
      setSubmitError('')
      return
    }

    const errorMessage = buildSupportBookedEventActionErrorMessage(
      response,
      'Failed to cancel booking',
    )
    setSubmitError(errorMessage)
    toast.error(errorMessage)
  }

  const handleClose = () => {
    setReason('')
    setRefundType('none')
    setSubmitError('')
    if (closeFunc) {
      closeFunc()
    }
  }

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperComponent={BootStrapDialogPaperComponent}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: 0,
          maxWidth: '520px',
        },
      }}
    >
      <div style={{ padding: '24px' }}>
        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ 
            fontSize: '20px', 
            fontWeight: 700, 
            color: 'rgba(0, 0, 0, 0.85)',
            margin: '0 0 8px 0',
            fontFamily: "'Inter', sans-serif"
          }}>
            Cancel Appointment
          </h2>
          <p style={{ 
            fontSize: '14px', 
            color: 'rgba(0, 0, 0, 0.6)',
            margin: 0,
            lineHeight: 1.5
          }}>
            Please provide a reason for cancellation and specify refund preference.
          </p>
        </div>
        
        <div style={{ 
          marginBottom: '20px',
          padding: '16px',
          background: 'rgba(67, 56, 202, 0.04)',
          borderRadius: '12px',
          border: '1px solid rgba(67, 56, 202, 0.1)'
        }}>
          <div style={{ 
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: 600,
            color: 'rgba(0, 0, 0, 0.85)'
          }}>
            Patient: {sessionData?.userName || 'N/A'}
          </div>
          <div style={{ 
            fontSize: '13px',
            color: 'rgba(0, 0, 0, 0.7)'
          }}>
            {sessionData?.startTime && sessionData?.endTime && (
              <>
                {dayjs.utc(sessionData.startTime).local().format('DD MMM YYYY, h:mm A')} - {' '}
                {dayjs.utc(sessionData.endTime).local().format('h:mm A')}
              </>
            )}
          </div>
        </div>

        {submitError ? (
          <div
            style={{
              marginBottom: '20px',
              padding: '12px 14px',
              borderRadius: '10px',
              background: 'rgba(254, 242, 242, 0.95)',
              border: '1px solid rgba(248, 113, 113, 0.25)',
              color: '#b91c1c',
              fontSize: '13px',
              lineHeight: 1.5,
              fontWeight: 500,
            }}
          >
            {submitError}
          </div>
        ) : null}

        {/* Reason Field */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            display: 'block',
            fontSize: '13px',
            fontWeight: 600,
            color: 'rgba(0, 0, 0, 0.85)',
            marginBottom: '8px'
          }}>
            Reason for Cancellation <span style={{ color: 'rgba(0, 0, 0, 0.5)', fontWeight: 400 }}>(Optional)</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for cancellation..."
            disabled={cancelLoading}
            style={{
              width: '100%',
              minHeight: '80px',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid rgba(0, 0, 0, 0.2)',
              fontSize: '14px',
              fontFamily: 'inherit',
              resize: 'vertical',
              outline: 'none',
              transition: 'border-color 0.2s ease',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'rgba(67, 56, 202, 0.5)'
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'rgba(0, 0, 0, 0.2)'
            }}
          />
        </div>

        {/* Refund Type Selection */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ 
            display: 'block',
            fontSize: '13px',
            fontWeight: 600,
            color: 'rgba(0, 0, 0, 0.85)',
            marginBottom: '12px'
          }}>
            Refund Recommendation
          </label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <label style={{ 
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: cancelLoading ? 'not-allowed' : 'pointer',
              padding: '12px',
              borderRadius: '8px',
              border: `2px solid ${refundType === 'none' ? 'rgba(67, 56, 202, 0.3)' : 'rgba(0, 0, 0, 0.1)'}`,
              background: refundType === 'none' ? 'rgba(67, 56, 202, 0.05)' : 'transparent',
              transition: 'all 0.2s ease',
            }}>
              <input
                type="radio"
                name="refundType"
                value="none"
                checked={refundType === 'none'}
                onChange={(e) => setRefundType(e.target.value)}
                disabled={cancelLoading}
                style={{ cursor: cancelLoading ? 'not-allowed' : 'pointer' }}
              />
              <div>
                <div style={{ fontSize: '14px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)' }}>
                  No Refund
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '2px' }}>
                  Patient will not receive a refund
                </div>
              </div>
            </label>
            <label style={{ 
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: cancelLoading ? 'not-allowed' : 'pointer',
              padding: '12px',
              borderRadius: '8px',
              border: `2px solid ${refundType === 'full' ? 'rgba(67, 56, 202, 0.3)' : 'rgba(0, 0, 0, 0.1)'}`,
              background: refundType === 'full' ? 'rgba(67, 56, 202, 0.05)' : 'transparent',
              transition: 'all 0.2s ease',
            }}>
              <input
                type="radio"
                name="refundType"
                value="full"
                checked={refundType === 'full'}
                onChange={(e) => setRefundType(e.target.value)}
                disabled={cancelLoading}
                style={{ cursor: cancelLoading ? 'not-allowed' : 'pointer' }}
              />
              <div>
                <div style={{ fontSize: '14px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)' }}>
                  Full Refund
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '2px' }}>
                  Recommend full refund to the patient
                </div>
              </div>
            </label>
          </div>
        </div>

        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          justifyContent: 'flex-end',
          marginTop: '24px'
        }}>
          <button
            onClick={handleClose}
            disabled={cancelLoading}
            style={{ 
              padding: '10px 24px',
              borderRadius: '10px',
              border: '1px solid rgba(0, 0, 0, 0.2)',
              background: '#fff',
              color: 'rgba(0, 0, 0, 0.85)',
              fontSize: '14px',
              fontWeight: 600,
              cursor: cancelLoading ? 'not-allowed' : 'pointer',
              opacity: cancelLoading ? 0.5 : 1,
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              if (!cancelLoading) {
                e.target.style.background = 'rgba(0, 0, 0, 0.05)'
              }
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#fff'
            }}
          >
            Keep Appointment
          </button>
          <button
            onClick={cancelSession}
            disabled={cancelLoading}
            style={{ 
              padding: '10px 24px',
              borderRadius: '10px',
              border: 'none',
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.95) 0%, rgba(220, 38, 38, 0.95) 100%)',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 600,
              cursor: cancelLoading ? 'not-allowed' : 'pointer',
              opacity: cancelLoading ? 0.7 : 1,
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.25)',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
            onMouseOver={(e) => {
              if (!cancelLoading) {
                e.target.style.background = 'linear-gradient(135deg, rgba(239, 68, 68, 1) 0%, rgba(220, 38, 38, 1) 100%)'
                e.target.style.boxShadow = '0 6px 16px rgba(239, 68, 68, 0.35)'
                e.target.style.transform = 'translateY(-1px)'
              }
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'linear-gradient(135deg, rgba(239, 68, 68, 0.95) 0%, rgba(220, 38, 38, 0.95) 100%)'
              e.target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.25)'
              e.target.style.transform = 'translateY(0)'
            }}
          >
            {cancelLoading ? (
              <>
                <Spinner animation="border" variant="light" size="sm" />
                Cancelling...
              </>
            ) : (
              'Cancel Appointment'
            )}
          </button>
        </div>
      </div>
    </BootstrapDialog>
  )
}

const BootstrapDialog = muiStyled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

const BootStrapDialogPaperComponent = muiStyled(Paper)(
  ({ theme }) => `
    max-width: unset !important;
`,
)
